applicationsSubNavbar.classy.controller({
    name: "SubNavbarAwardLettersController",
    inject: [
        "$scope", "authServiceFactory", "AwardLetterTemplatesModelService", "AwardLetterModelService",
        "AwardLettersModalService", "ApplicationService", "NoteModelService", "PermissionModelService",
        "ModelService", "$modal", "$sce"
    ],
    init: function() {
        this.$.$sce = this.$sce;
        this.$.ApplicationService = this.ApplicationService;
        this.$.AwardLetterTemplatesModelService = this.AwardLetterTemplatesModelService;
        this.$.read = this.authServiceFactory.getAuth().permissions.readOnly;
        this.$.AwardLettersModalService = this.AwardLettersModalService;
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
    }
});
